module.exports = __webpack_public_path__ + "img/cover.c8ce63cc.png";